import { Component, OnInit } from '@angular/core';
import { AccountService } from '../shared/account.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfirmDialogComponent } from '../../shared/modals/confirm/confirm-dialog.component';
import { Router } from '@angular/router';

import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports
import { default as _rollupMoment } from 'moment';

const moment = _rollupMoment || _moment;

@Component({
  selector: 'app-account-dashboard',
  templateUrl: './account-dashboard.component.html',
  styleUrls: ['./account-dashboard.component.scss'],
})
export class AccountDashboardComponent {

  titleText = 'ダッシュボード';

  months = [-1, -2].map(value => ({label: moment().add(value, 'month').format('YYYY年MM月'), value}));
  offset = -1;

  constructor(
    private _accountService: AccountService,
    private _snackBar: MatSnackBar,
    private _router: Router,
    public dialog: MatDialog,
  ) {  }

  async onClickArchiveButton() {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: { title: '確認', message: '確定しますか？この処理は一度行なうと取り消せません。' }
    });

    dialogRef.afterClosed().subscribe(async result => {
      if (result) {
        try {
          await this._accountService.archiveAccounts(this.offset);
          this._snackBar.open('処理が完了しました。', undefined, { duration: 2000 });
          this._router.navigate(['/']);
        } catch (err) {
          console.error(err);
          this._snackBar.open('エラーが発生しました。', undefined, { duration: 2000 });
          this._router.navigate(['/']);
        }
      }
    });
  }
}
